import { render, staticRenderFns } from "./H5Login.vue?vue&type=template&id=3bc28a77&scoped=true"
import script from "./H5Login.vue?vue&type=script&lang=js"
export * from "./H5Login.vue?vue&type=script&lang=js"
import style0 from "./H5Login.vue?vue&type=style&index=0&id=3bc28a77&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc28a77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc28a77')) {
      api.createRecord('3bc28a77', component.options)
    } else {
      api.reload('3bc28a77', component.options)
    }
    module.hot.accept("./H5Login.vue?vue&type=template&id=3bc28a77&scoped=true", function () {
      api.rerender('3bc28a77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/h5/H5Login.vue"
export default component.exports